import { c as _c } from "react/compiler-runtime";
import { MediaItem } from "./media-utils";
interface MediaThumbnailProps {
  readonly media: MediaItem;
}

/**
 * Component to display a thumbnail of an image or video
 */
export default function MediaThumbnail(t0) {
  const $ = _c(4);
  const {
    media
  } = t0;
  let t1;
  if ($[0] !== media.alt || $[1] !== media.type || $[2] !== media.url) {
    t1 = media.type === "image" ? <img src={media.url} alt={media.alt} className="tw-inline tw-h-4 tw-w-4 tw-object-cover tw-rounded" /> : <span className="tw-inline-flex tw-items-center tw-justify-center tw-h-4 tw-w-auto tw-px-1 tw-bg-iron-800 tw-rounded tw-text-xs tw-text-iron-400" title={media.alt}>▶</span>;
    $[0] = media.alt;
    $[1] = media.type;
    $[2] = media.url;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}